import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appInflatorContainer]',
  standalone: false
})
export class InflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
